export default "__VITE_ASSET__$FXIgrRq__"